import axios from '@/libs/api.request'
import config from '@/config'
import { paramFormat } from '@/api/fn'
import { getToken } from '@/libs/util'
const baseUrl =
  process.env.NODE_ENV === 'development'
    ? config.baseUrl.dev
    : config.baseUrl.pro

export default {
  queryProjectList (data) {
    let token = getToken()
    let param = paramFormat(data)
    return axios.request({
      url: baseUrl + '/sys/project/queryProjectList',
      data: param,
      dataType: 'json',
      headers: {
        token: token,
        'Content-Type': 'application/json;charset=utf-8'
      },
      method: 'POST'
    })
  },
  newProject (data) {
    let token = getToken()
    let param = paramFormat(data)
    return axios.request({
      url: baseUrl + '/sys/project/newProject',
      data: param,
      dataType: 'json',
      headers: {
        token: token,
        'Content-Type': 'application/json;charset=utf-8'
      },
      method: 'POST'
    })
  },
  updateProjectById (data) {
    let token = getToken()
    let param = paramFormat(data)
    return axios.request({
      url: baseUrl + '/sys/project/updateProjectById',
      data: param,
      dataType: 'json',
      headers: {
        token: token,
        'Content-Type': 'application/json;charset=utf-8'
      },
      method: 'POST'
    })
  },
  queryProjectById (data) {
    let token = getToken()
    let param = { 'id': data.id }
    let url = baseUrl + '/sys/project/sys/queryProjectById/' + param.id
    return axios.request({
      url: url,
      dataType: 'json',
      headers: {
        token: token,
        'Content-Type': 'application/json;charset=utf-8'
      },
      method: 'GET'
    })
  },
  queryProjectByFilter (data) {
    let token = getToken()
    let param = paramFormat(data)
    let url = baseUrl + '/sys/project/sys/queryProjectByFilter'
    return axios.request({
      url: url,
      data: param,
      dataType: 'json',
      headers: {
        token: token,
        'Content-Type': 'application/json;charset=utf-8'
      },
      method: 'GET'
    })
  },
  deleteProjectById (data) {
    let token = getToken()
    let param = paramFormat(data)
    return axios.request({
      url: baseUrl + '/sys/project/deleteProjectById',
      data: param,
      dataType: 'json',
      headers: {
        token: token,
        'Content-Type': 'application/json;charset=utf-8'
      },
      method: 'POST'
    })
  }
}
